import(/* webpackMode: "eager" */ "/app/src/app/(public)/inspection-policy/page.tsx");
